import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../components/layout/Sidebar';
import { Header } from '../components/layout/Header';
import { UpdateNotification } from '../components/notifications/UpdateNotification';
import { BillingDeadlineNotification } from '../components/notifications/BillingDeadlineNotification';
import { useAuth } from '../contexts/AuthContext';

export function DashboardPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showUpdateNotification, setShowUpdateNotification] = useState(true);
  const { user, needsUpdate } = useAuth();

  return (
    <div className="min-h-screen bg-gray-100">
      <BillingDeadlineNotification />
      {needsUpdate && showUpdateNotification && (
        <UpdateNotification
          onDismiss={() => setShowUpdateNotification(false)}
        />
      )}
      <Header 
        isSidebarOpen={isSidebarOpen}
        onSidebarToggle={() => setIsSidebarOpen(!isSidebarOpen)}
      />
      <div className="flex pt-16">
        <Sidebar 
          isOpen={isSidebarOpen} 
          onClose={() => setIsSidebarOpen(false)} 
        />
        <div className="flex-1 p-4 lg:p-8 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}